import React from 'react'
import BrandMultiplierItem from './BrandMultiplierItem'
import LoadingSkeleton from './LoadingSkeleton'

export default function FormCategoryMultiplier(props) {
    const {
        brandsLoading,
        brands,
        brandsLoadingIndicator,
        updateMultiplier, multipliers
    } = props

    return (
        <div id="app-category-multiplier-view">
            <div className="inner">
                {
                    brandsLoading && (
                        <React.Fragment>
                            {
                                brandsLoadingIndicator?.length ? brandsLoadingIndicator.map(item => (
                                    <React.Fragment key={item}>
                                        <LoadingSkeleton />
                                    </React.Fragment>
                                )) : null
                            }
                        </React.Fragment>
                    )
                }
                {
                    brands?.length ? brands.map((item, index) => {
                        const multiplier = multipliers.find(e => e.brand_id === item.manufacturer_id) || {}
                        return (
                            <React.Fragment key={item.manufacturer_id}>
                                <BrandMultiplierItem
                                    brandItem={item}
                                    brandItemIndex={index}
                                    updateMultiplier={updateMultiplier}
                                    multiplier={multiplier}
                                />
                            </React.Fragment>
                        )
                    }) : (!brandsLoading && (
                        <p className="no-data-found text-center ">No data found</p>
                    ))
                }
            </div>
        </div>
    )
}
